import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { compose, withApollo } from "react-apollo";
import { useSelector } from "react-redux";
import CustomSingleSelect from "../../../components/shared/CustomSingleSelect";
import BUTTON_MODEL_LABEL from "../../../utils/constants/buttonModelLabel";
import { Module, TOPBANNER_LABEL, TOPBANNER_SHORTNAME, NOTIFICATIONS_BANNER_APP, DURATION, NOTIFICATIONS_BANNER } from "../../../constants";
import { topBannerMessageValidationSchemaFactory } from "./top-banner-message-validation-schema";
import { TopBannerMessagenotify } from "./Top-Banner-Message-notify";
import { AdminPanelContext } from "../../context/context";
import { OwcButton, OwcTypography, OwcIcon, OwcInput, OwcTextarea, OwcModalDialog, OwcSelectDropdown, OwcListItem } from "@one/react";
import { Autocomplete, CircularProgress, Popper, TextField } from "@mui/material";
import styles from "./TopBannerMessageNotifyForm.module.scss";
import { generateID } from "@digitallab/grid-common-components";
import { OwcDatepicker } from "@one/react";
import gql from "graphql-tag";
import { API } from "aws-amplify";
import { debounce } from "lodash";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import { configureAwsAppSync } from "../../../utils/helpers/configureAwsAppSync";
import locale from "date-fns/locale/en-US";
import styled from "styled-components";
import { convertDate } from "../../../utils/helpers/helper";
import { getAllData } from "../../../utils/helpers/fetching";
import { LIST_SITES } from "../../../gql/landingapi/queries";

const CIDM_LIMIT = 50;

const GET_CIDM_GROUPS_NAMES = gql`
  query GetCidmGroupsNames($input: CidmGroupQueryInput!) {
    getCidmGroupsNames(input: $input) {
      groupId
      groupName
    }
  }
`;

const colorOptions = Object.values(NOTIFICATIONS_BANNER).map((value) => ({
  value,
  label: value
}));


const CustomPopper = (props) => {
  return <Popper {...props} placement="bottom" />;
};

const { adminTopBannerMessage } = Module.PAGE.ADMIN;

const appOptions = Object.values(NOTIFICATIONS_BANNER_APP).map((value) => ({
  value,
  label: value
}));
const TopBannerMessageTextFiled = ({ formik, shortName, label, inputLength, ...props }) => {
  return (
    <OwcInput
      onBlur={formik.handleBlur}
      data-testid={`send-group-notify-${shortName}-input`}
      helperText={formik.touched[shortName] && formik.errors[shortName]}
      error={formik.errors[shortName]}
      validation-mode="realtime"
      name={shortName}
      label={label}
      value={formik.values[shortName]}
      onInputChange={formik.handleChange}
      onInputKeyDown={formik.handleChange}
      maxLength={inputLength}
      type="text"
      variant="filled"
      id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "input_field")}
      {...props}
    >
      {formik.errors[shortName] && (
        <>
          <span id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "error_slot")} slot="error-text">
            {formik.errors[shortName]}
          </span>
        </>
      )}
      {formik.values[shortName] !== "" && (
        <OwcIcon
          id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "icon_clear_circle")}
          name="circle_clear_filled"
          slot="suffix"
          type="legacy"
          onClick={() => formik.setFieldValue(shortName, "", true)}
        />
      )}
    </OwcInput>
  );
};
const onSubmitFactory = (client, setValue, cancel, refetch) => {
  return async (values) => {

    TopBannerMessagenotify(client, values, setValue, cancel, refetch);
    setTimeout(() => {
      setValue("");
      setValue("topBannerMessage");
    }, 2000);
  };

};


export const FieldRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;

  & > .selectBox,
  .TextFieldInput {
    margin: 0;
    margin-right: 20px;
    min-width: 48%;
    max-width: 100%;
  }

  & > .datePickerStyle {
    margin: 0;
    margin-right: 20px;
    width: 100%;
  }
`;

const TopBannerMessageNotifyForm = ({
  client,
  application,
  open,
  cancel,
  title,
  refetch
}) => {
  const { setValue } = useContext(AdminPanelContext);
  const [cidmOptions, setCidmOptions] = useState([]);
  const [cidmSearchLoading, setCidmSearchLoading] = useState(false);
  const [limitReached, setLimitReached] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const user = useSelector((state) => state.user);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: topBannerMessageValidationSchemaFactory,
    initialValues: { ...application },
    isInitialValid: false,
    onSubmit: onSubmitFactory(client, setValue, refetch, cancel)
  });


  const BOOKING_config = {
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_BOOKING_ENDPOINT
  };


  const debouncedFetchGroups = useRef(
    debounce(async (value) => {
      setCidmSearchLoading(true);
      try {
        configureAwsAppSync(BOOKING_config);
        const { data } = await API.graphql({
          query: GET_CIDM_GROUPS_NAMES,
          client,
          variables: {
            input: { groupName: value },
          },
          fetchPolicy: "no-cache",
        });
        const list = data?.getCidmGroupsNames ?? [];
        setCidmOptions(list);
        //FIXME: quick detection of limit reached until Backend can send that flag
        setLimitReached(list.length === CIDM_LIMIT);

      } catch (err) {
        console.error("CIDM autocomplete error", err);
        snackbarService.show({
          type: "error",
          message: "Unable to load CIDM groups. Please try again later.",
          duration: DURATION,
        });
        setCidmOptions([]);
        setLimitReached(false);
      } finally {
        setCidmSearchLoading(false);
      }
    }, 300)
  ).current;


  useEffect(() => {
    if (user !== undefined) {
       formik.setFieldValue('userId', user.email);
    }

    if (
      formik.values.cidmGroupName &&
      formik.values.groupId &&
      !cidmOptions.length
    ) {
      setCidmOptions([
        {
          groupName: formik.values.cidmGroupName,
          groupId: formik.values.groupId,
        },
      ]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values, open, user]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const { items } = await getAllData({
          client,
          query: LIST_SITES,
          dataPath: ["data", "listSites"]
        });
         const newSiteAll = { siteName: "All" }
         setSiteOptions([newSiteAll, ...items]);
      } catch (err) {
        snackbarService.show({
          type: "error",
          message: "Unable to load site. Please try again later.",
          duration: DURATION,
        });
        setSiteOptions([]);
      } 
    };
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OwcModalDialog
      visible={open}
      disableBackdropClick
      size="sm"
      id={generateID.UUID(Module.PAGE.ADMIN.applicationModal, `appAndCategories`, "dialog")}
      className="owcmodalZIndex"
    >
      {open && (
        <div
          id={generateID.UUID(Module.PAGE.ADMIN.applicationModal, `appAndCategories`, "div")}
          style={{ height: 450, maxHeight: 450, minHeight: 450 }}
        >
          <div
            id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "mainbox")}
            className={styles.mainBoxForm}
            data-testid="main-box-form-for-send-group-notify"
          >
            <FieldRow>
              <OwcTextarea
                name={TOPBANNER_SHORTNAME.heading}
                label={TOPBANNER_LABEL.displayTitle}
                value={formik.values["heading"]}
                onInputChange={formik.handleChange}
                onInputKeyDown={formik.handleChange}
                error-text={formik.errors["heading"]}
                onInputReset={() => formik.setFieldValue("heading", "", true)}
                reset
                required
                validation-mode="realtime"
                variant="filled"
                id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "topbanner_textarea")}
                style={{ width: "100%", marginTop: 20, marginRight: 15, paddingBottom: 0 }}
              />
              <TopBannerMessageTextFiled
                style={{ width: "100%", marginTop: 20, marginRight: 15 }}
                className="selectBox"
                formik={formik}
                shortName={TOPBANNER_SHORTNAME.infoURL}
                label={TOPBANNER_LABEL.url}
                id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "topbanner_2")}
              />
            </FieldRow>
            <OwcTextarea
              name={TOPBANNER_SHORTNAME.displayText}
              label={TOPBANNER_LABEL.diplayText}
              value={formik.values["displayText"]}
              onInputChange={formik.handleChange}
              onInputKeyDown={formik.handleChange}
              error-text={formik.errors["displayText"]}
              onInputReset={() => formik.setFieldValue("displayText", "", true)}
              reset
              required
              maxLength={100}
              minLength={0}
              validation-mode="realtime"
              cols="18"
              rows={3}
              variant="filled"
              id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "topbanner_textarea")}
            />
            <FieldRow>
              <CustomSingleSelect
                onChange={(e) => {
                  formik.setFieldValue("app", e);
                }}
                style={{ width: "100%", marginTop: 15, marginRight: 15 }}
                formik={formik}
                options={appOptions}
                selectLabel={TOPBANNER_LABEL.selectAppCategory}
                required
                name="app"
                value={formik.values.app}
                propValue={"value"}
                propLabel={"label"}
                testid="top-banner-message-color-input"
                error-text={formik.errors["app"]}
                id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "custom_single_select")}
              />
              <OwcSelectDropdown
                label="Select Site*"
                name="site"
                dataTestid="site-set-select-dropdown"
                style={{ width: "100%", marginTop: 15, marginRight: 15 }}
                required
                error-text={formik.errors["site"]}
                validation-mode="realtime"
                onSelectChange={(e) => {
                  const idx = e.detail[0];
                  formik.setFieldValue("site", siteOptions[idx]?.siteName);
                }}
              >
                {siteOptions.map((option, idx) => {
                  const isSelected =
                    formik.values.site === option.siteName
                  return (
                    <OwcListItem
                      key={`${option.siteName}-${idx}`}
                      value={option.siteName}
                      selected={isSelected}
                    >
                      {option.siteName}
                    </OwcListItem>
                  );
                })}
              </OwcSelectDropdown>
            </FieldRow>
            {formik.values.app === "Booking" && (
              <>
                <FieldRow>
                  <Autocomplete
                    key={formik.values?.cidmGroupName}
                    value={cidmOptions.find((o) => o.groupName === formik.values.cidmGroupName) || formik.values.cidmGroupName}
                    PopperComponent={CustomPopper}
                    disablePortal
                    options={cidmOptions}
                    style={{ width: "100%" }}
                    className="selectBox"
                    getOptionLabel={(option) => option.groupName || formik.values.cidmGroupName || ""}
                    loading={cidmSearchLoading}
                    isOptionEqualToValue={(opt, val) => opt?.groupId === val?.groupId}
                    onInputChange={(_, v, reason) => {
                      if (reason === "input" && v.length >= 4) {
                        debouncedFetchGroups(v)
                      };
                    }}
                    onChange={(event, value) => {
                      formik.setFieldValue('cidmGroupName', value?.groupName || '');
                      formik.setFieldValue('groupId', value?.groupId || '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="outlined-required"
                        className="selectBox"
                        variant="standard"
                        label="CIDM Group Name"
                        size="small"
                        value={formik.values.cidmGroupName}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {cidmSearchLoading ? <CircularProgress size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                  {limitReached && (
                    <OwcTypography
                      variant="badge"
                      style={{ color: '#ed6c02', fontFamily: 'inherit', fontSize: 'small', marginBottom: '20px', fontWeight: '500' }}
                    >
                      Only first 50 are displayed – please narrow down your search
                    </OwcTypography>
                  )}
                </FieldRow>
              </>
            )}
            <FieldRow>
              <OwcDatepicker
                locale={{
                  ...locale,
                  options: {
                    ...locale.options,
                    weekStartsOn: 1
                  }
                }}
                required
                className="datePickerStyle"
                disableToolbar
                refuse={/[^\dA-Za-z]+/gi}
                format="dd-MMM-yyyy"
                data-testid="from-test-id"
                id="from"
                name="from"
                label="Select from date*"
                value={formik.values.from ? new Date(formik.values.from) : null}
                onValueChange={(e) => {
                  formik.setFieldValue("from", convertDate(e.detail), true);
                }}
                variant="inline"
                maxDate={formik.values.to ? new Date(formik.values.to) : {}}
                minDate={new Date().getTime()}
                error={formik.touched.from && Boolean(formik.errors.from)}
                helperText={formik.touched.from && formik.errors.from}
                FormHelperTextProps={{
                  "data-testid": "test-helpf-from-date"
                }}
                autoClose
              />
              <OwcDatepicker
                locale={{
                  ...locale,
                  options: {
                    ...locale.options,
                    weekStartsOn: 1
                  }
                }}
                required
                className="datePickerStyle"
                disableToolbar
                refuse={/[^\dA-Za-z]+/gi}
                format="dd-MMM-yyyy"
                data-testid="to-test-id"
                id="to"
                name="to"
                label="Select to date*"
                minDate={formik.values.from ? new Date(formik.values.from) : new Date().getTime()}
                value={formik.values.to ? new Date(formik.values.to) : null}
                onValueChange={(e) => {
                  formik.setFieldValue("to", convertDate(e.detail), true);
                }}
                variant="inline"
                error={formik.touched.to && Boolean(formik.errors.to)}
                helperText={formik.touched.to && formik.errors.to}
                FormHelperTextProps={{
                  "data-testid": "test-help-to-date"
                }}
                autoClose
              />
            </FieldRow>
            <CustomSingleSelect
              onChange={(e) => {
                formik.setFieldValue("color", e);
              }}
              formik={formik}
              style={{ width: "100%", marginTop: 15, marginRight: 15 }}
              options={colorOptions}
              selectLabel={TOPBANNER_LABEL.selectColorCategory}
              required={true}
              showColor={true}
              name="color"
              value={formik.values.color}
              propValue={"value"}
              propLabel={"label"}
              testid="top-banner-message-color-input"
              id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "custom_single_select")}
            />
            <div
              id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "title_toggle")}
              className={styles.titleslidetoggle}
            >
            </div>
          </div>
        </div>
      )}
      <div slot="header" id={generateID.UUID(Module.PAGE.ADMIN.applicationModal, `appAndCategories_header`, "dialog")}>
        {title}
      </div>
      <div
        slot="actions"
        style={{ display: "flex", justifyContent: "right" }}
        id={generateID.UUID(Module.PAGE.ADMIN.applicationModal, `appAndCategories_actions`, "dialog")}
      >
        <OwcButton
          data-testid="admin-panel-modal-application-action-button-cancel"
          variant="secondary"
          onClick={() => cancel()}
          style={{ marginRight: 32 }}
          id={generateID.UUID(Module.PAGE.ADMIN.applicationModal, `appAndCategories_cancel_button`, "dialog")}
        >
          {BUTTON_MODEL_LABEL.cancel}
        </OwcButton>
        <OwcButton
          aria-label={"Save"}
          data-testid="top-banner-message-button"
          onClick={() => {
            formik.submitForm();
          }}
          disabled={!formik.isValid || formik.isSubmitting}
          id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "button_save")}
        >
          {formik.isSubmitting && (
            <CircularProgress
              data-testid="circular-progress-top-banner-message-button"
              color="primary"
              size={20}
              style={{ marginRight: 6 }}
              id={generateID.UUID(adminTopBannerMessage, `topBannerMessage`, "circlularProgress")}
            />
          )}
          {application.id ? BUTTON_MODEL_LABEL.save : BUTTON_MODEL_LABEL.add}
        </OwcButton>
      </div>
    </OwcModalDialog>
  );
};

export default compose(
  withApollo
)(TopBannerMessageNotifyForm);